import React, { Component } from 'react';
import { AuthContext } from "./../../context/auth";
import { Link } from "react-router-dom";

class TopNavHomeComponent extends Component{
    static contextType = AuthContext;

    handleClick = () =>{
        document.querySelector('.country-list').classList.remove("hide")
        document.querySelector('.selected-flag .arrow').classList.remove("down")
        document.querySelector('.selected-flag .arrow').classList.add("up")
        document.querySelector('.selected-flag').classList.add("expanded")
    }

    render(){
        return (
            <React.Fragment>
                <div className="inner-navbar d--xs-none">
                    <div className="container">

                        <div className="inner-navbar-fit">
                            <h1 className="text-hide">
                                <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link logo-replacement"
                                      style={{backgroundImage: "url('"+process.env.PUBLIC_URL+"/image/silverback-logo-text.png')"}}></Link>
                                Host4VIP
                            </h1>
                            <div className="ml-auto d-flex align-items-center">
                                <Link to={`${process.env.PUBLIC_URL}/`} className="top--skipbar-color"><i className="fa fa-share"
                                                                                                          aria-hidden="true"></i>Skip</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="banner-choose-deal flex-center d-none"
                     style={{backgroundImage: "url('"+process.env.PUBLIC_URL+"/image/banner-choose-group.png')"}}>
                    <h4 className="banner-choose-deal-heading">Login</h4>
                </div>
                <div className="container">
                    <div className="top--skipbar custom-skipbar d-lg-none">
                        <button onClick={this.handleClick} type="button" className="top--skipbar-color cc"><i className="fa fa-flag" aria-hidden="true"></i>Change country</button>
                        <Link to={`${process.env.PUBLIC_URL}/`} className="top--skipbar-color"><i className="fa fa-share"
                                                                                                  aria-hidden="true"></i>Skip</Link>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default TopNavHomeComponent;